import { VALIDATION_RULES } from '../Common/validation'

export class ValidationService {
  static validateField(name, value, formData = {}) {
    const rules = VALIDATION_RULES[name]
    if (!rules) return ""

    if (rules.required && !value.trim()) {
      return `${name.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())} is required`
    }

    if (rules.minLength && value.length < rules.minLength) {
      return `Must be at least ${rules.minLength} characters`
    }

    if (rules.maxLength && value.length > rules.maxLength) {
      return `Must be no more than ${rules.maxLength} characters`
    }

    if (rules.pattern && !rules.pattern.test(value)) {
      return rules.message
    }

    if (rules.validate) {
      const result = rules.validate(value, formData)
      if (result !== true) return result
    }

    return ""
  }

  static validateStep(stepNumber, formData) {
    const fieldsToValidate = stepNumber === 1 
      ? ['first_name', 'last_name', 'email']
      : ['username', 'phone_number', 'password', 'password2']

    const errors = {}
    let isValid = true

    fieldsToValidate.forEach(field => {
      const error = this.validateField(field, formData[field], formData)
      if (error) {
        errors[field] = error
        isValid = false
      }
    })

    return { isValid, errors }
  }
}